import { propTypes, withFormsy } from 'formsy-react'
import React, { Component } from 'react'
import PropTypes from 'prop-types';

//import '../../../assets/css/chkbox-style.css'
import './DGCheckbox.less'

class DGCheckbox extends Component {

    componentDidMount() {

    }

    changeValue = (event) => {
        
        /*if (this.props.childUpdated)
            this.props.childUpdated(this.props.value);*/

        if(this.props.onChange){
            this.props.onChange(event, { name: this.props.name, value: event.currentTarget.checked });
            
        }
        else{
            this.props.setValue(event.currentTarget.checked ? 'checked' : null);
        }
    };
    render() {
        return (
            <div className="chkbox-field">
                <label class="checkbox">
                    {this.props.radio &&
                        <input type="radio" name={this.props.name} onChange={this.changeValue} />
                    }
                    {!this.props.radio &&
                        <input type="checkbox" name={this.props.name} checked={this.props.value} onChange={this.changeValue} disabled={this.props.disabled} />
                    }
                    <span class="checkbox__icon"></span>
                    <span class={`text ${this.props.disabled? 'disabled': ''}`}>{this.props.label}</span>
                </label>
            </div>
        )
    }
}

DGCheckbox.propTypes = {
    label: PropTypes.string,
    radio: PropTypes.bool,
    ...propTypes
};


export default withFormsy(DGCheckbox)
